import React, { useContext, useEffect, useState } from 'react'
import {QuestionnaireCodeProvider,QuestionnaireCodeContext} from './QuestionnaireCodeContext';
import RecipientSelection from '../DevelopmentLogin/RecipientSelection'
import { addAnonymousInstance, EraseExpiredFormAnswer } from '../../services/dataService';
import { Button } from 'react-bootstrap';
import * as Constants from '../Common/CommonConstants';
import ReCaptcha from  "../reCaptcha"

export function UnidentifyKeyEntryDialog(props) {
    const { key1, setKey1, key2, setKey2, error, setUnidentifySub, activeNAICMember, instanceState } = useContext(QuestionnaireCodeContext);
    //const formId = props.id;

    const handleLoggedIn = async (userInfo, formId, formExpired, keyFieldValues) => {
        //console.log("!!!" + userInfo.label + "," + userInfo.recipientID + "," + userInfo.targetID + "," + formId + "," + userInfo.wCIOStateCode + "," + userInfo.formStatus + "," + userInfo.lastUpdated + "," + formExpired);
        //use recipentid and questionnairId to create a qinstance
        // keyFieldValues: answers from key-field modal (TagName -> value), used for multi-submission identity
        if (userInfo && formId) {
            // LW260806 Co#5394: reopen the selected existing QInstance (complete or incomplete)
            const existingId = userInfo.qInstanceID || userInfo.qInstanceId || userInfo.QInstanceID || 0;
            if (existingId) {
                // Still go through CreateAnonymousInstance so server validates formId/recipientId ownership
                const instanceId = await addAnonymousInstance(userInfo.recipientID, userInfo.targetID, formId, {}, existingId);
                if (instanceId > 0) {
                    setKey1(instanceId);
                    setKey2(userInfo.recipientID);
                    setUnidentifySub(true);
                }
                return;
            }
            // Do not delete expired form answer after certain days
            //if (formExpired && userInfo.recipientID > 0 && userInfo.targetID > 0) {
            //    await EraseExpiredFormAnswer(userInfo.recipientID, userInfo.targetID, formId);
            //}
            const instanceId = await addAnonymousInstance(userInfo.recipientID, userInfo.targetID, formId, keyFieldValues, 0)
            //console.log("new instanceId=" + instanceId);
            if (instanceId > 0) {
                setKey1(instanceId);
                setKey2(userInfo.recipientID);
                setUnidentifySub(true);
            }
        }
    }
    return (
        <div className="user-message-wrapper fadeInDown">
            <div className="login-form-content">
                {/*<div  className="pcrb-logo"></div>*/}
                {/*<h4 className="code-login-welcome">*/}
                {/*    FormId: {props.id}*/}
                {/*</h4>*/}
                {/*<h6 className="code-unidentifylogin-text">Enter code below to access*/}
                {/*</h6>*/}
                <RecipientSelection handleUserSelected={handleLoggedIn} {...props} ></RecipientSelection>

                <UnidentifyEntryControl instanceState={instanceState} activeNAICMember={activeNAICMember}  {...props}></UnidentifyEntryControl>
            </div>
        </div>
    )}



const renderButton = ({ afterCodeConfirmationAction, buttonText, submitEnabled }) =>{
    const { key1, setKey1, key2, setKey2, setLoading } = useContext(QuestionnaireCodeContext); //openAnonymousForm, 
    //console.log('submitEnabled=' + submitEnabled);

    return (
        <Button disabled={ !submitEnabled } onClick={() => { setLoading(true); afterCodeConfirmationAction() }}  > {/*disabled={!(key1 && key2)}*/}
            {renderButtonText(buttonText)}
        </Button>);
}

const renderButtonText=(buttonText)=>{

    const {loading} = useContext(QuestionnaireCodeContext);
    if(loading)
        return (
            <span>
                <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                <span> Loading...</span>
            </span>);
    else
        return(<span>{buttonText}</span>);
}

export function UnidentifyEntryControl({ instanceState, activeNAICMember, ...props}) {
    const { formName, key1, setKey1, key2, setKey2, token, setToken, error, formState, searchResult } = useContext(QuestionnaireCodeContext);
    //console.log("searchResult in UnidentifyEntryControl==[" + searchResult+"]");
    //console.log("token length=" + token.length);
    //console.log("activeNAICMember=[" + activeNAICMember + "]");  activeNAICMember = "active"/"inactive"/""
    //const [token, setToken] = useState('');
    const [submitEnabled, setSubmitEnabled] = useState(false);
    //05292026 - YA#5130 - QA environment reCAPTCHA is enabled
    const showReCaptcha = process.env.REACT_APP_SKIPRECAPTCHA === "TRUE" ? false : true;

    useEffect(() => {
        if (!showReCaptcha && (instanceState === "" || instanceState !== Constants.READ_ONLY_MODE) && searchResult != "nomatch" && ((formName.toLowerCase().indexOf(Constants.FormName_MemberShip) > -1 && activeNAICMember != "active") || formName.toLowerCase().indexOf(Constants.FormName_MemberShip) == -1)) {
            setSubmitEnabled(true);
        }
        else if ((instanceState === "" || instanceState !== Constants.READ_ONLY_MODE) && token.length && searchResult != "nomatch" && ((formName.toLowerCase().indexOf(Constants.FormName_MemberShip) > -1 && activeNAICMember != "active") || formName.toLowerCase().indexOf(Constants.FormName_MemberShip) == -1)) {
            setSubmitEnabled(true);
        }
        else {
            setSubmitEnabled(false);
        }
    }, [token, activeNAICMember, searchResult, instanceState])
    // LW251218 CO#4080 Intermediary Page and Security Check Points

    const handleToken = (token) => {
        setToken(token);
    }

    return(
        <div>
            {/*<form className="form-inline" style={{ "justifyContent": "center" }} >     */}
            {/*    <div>*/}
            {/*            <input value={key1} onChange={evt => setKey1(evt.target.value)} className="form-control code-input-box " disabled />     */}
            {/*        <span style={{"margin":"8px"}}>-</span>*/}
            {/*            <input value={key2} onChange={evt => setKey2(evt.target.value)} className="form-control code-input-box " disabled />*/}
            {/*    </div>*/}
            {/*</form>*/}
            {/*<br></br>*/}
            {error == "401" &&
                <div>
                    <div className="code-login-error">The code that you have entered is incorrect. Please check code, and try again or contact Central Support at centralsupport@pcrb.com</div>
                    <br></br>
                </div>
            }
            {showReCaptcha &&
                <div className="centerImage">
                    <ReCaptcha sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY} callback={handleToken} />
                    <br></br>
                </div>
            }
            <div>
                <br></br>
                {renderButton({ submitEnabled, ...props })}
            </div>

        </div>);
}

